import { render, staticRenderFns } from "./task-profile-material-report.vue?vue&type=template&id=a4caa590&scoped=true"
import script from "./task-profile-material-report.vue?vue&type=script&lang=js"
export * from "./task-profile-material-report.vue?vue&type=script&lang=js"
import style0 from "./task-profile-material-report.vue?vue&type=style&index=0&id=a4caa590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4caa590",
  null
  
)

export default component.exports